
import React from "react";

import { useTranslation } from 'react-i18next';

// Custom Componenets:
import QuickContact from "../../components/MobileContact/QuickContact";
import ContactForm from "../../components/contactForm/ContactForm";

// MUI Components:
import Box   from '@mui/material/Box';
import Paper from '@mui/material/Paper';


// Images:
import image_profile from './../../assets/images/profilePic.jpg';

function Contact() {

    const { t, i18n } = useTranslation();

    return (

        <Box width={'100%'} display={'flex'}
            flexDirection={{xs:'column', sm:'row',md:'row', lg:'row', xl:'row'}}>
            <Paper
                elevation={2} 
                sx={{ width:{ xs:'90%', sm:'90%',md:'30%', lg:'30%', xl:'30%' },
                        padding:'0.5rem',
                        margin:'1rem',
                        borderRadius:'1rem'
                }}>
                <QuickContact/>
            </Paper>

            <Paper
                elevation={2}
                sx={{ width:{ xs:'90%', sm:'90%',md:'60%', lg:'60%', xl:'60%' },
                      display:{xs:'block',sm:'block',md:'block',lg:'block',xl:'block'},                         
                        padding:'1rem',
                        margin:'1rem',
                        borderRadius:'1rem'
                }}>
                <ContactForm/>
            </Paper>
        </Box>
    );
}
export default Contact;